import { all, takeLatest } from 'redux-saga/effects';
import { fetchPromoMixItems } from 'store/promoMixItems/actions';
import fetchPromoMixItemsWorker from './worker.fetchPromoMixItems';

function* promoMixItemsSaga() {
  yield all([takeLatest(fetchPromoMixItems, fetchPromoMixItemsWorker)]);
}

export default promoMixItemsSaga;
